module.exports = __webpack_public_path__ + "4dcbf715fd638041d14b03dfe7664b53.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2010_teaser_image.jpg
// module id = 557
// module chunks = 0